import { RootState } from '..';
import { ordersAdapter } from './ordersSlice';

const ordersSelectors = ordersAdapter.getSelectors((state: RootState) => state.orders.orders);
export const getOrder = (state: RootState, salesId: string) => ordersSelectors.selectById(state, salesId);
